import React, { useState, useEffect } from 'react';
import HeroSection from '../public/components/HeroSection';
import FeaturesSection from '../public/components/FeaturesSection';
import CoursesSection from '../public/components/CoursesSection';
import TestimonialsSection from '../public/components/TestimonialsSection';
import CompaniesSection from '../public/components/CompaniesSection';
import CallToActionSection from '../public/components/CTASection';
import FloatingContactOptions from '../../components/layout/FloatingContactOptions';
import ChatBot from './ChatBot';
import { getPageContent } from '../../services/pageService';
import Loader from '../../components/common/Loader';

import { usePageMeta } from '../../hooks/usePageMeta';

const Home: React.FC = () => {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  usePageMeta({
    title: 'ShreeGuruCool | SAP S/4HANA Coaching - SD, MM, LE',
    description:
      'Join India’s top SAP S/4HANA coaching platform. Learn SD, MM, and LE modules with offline classes, expert mentors, real-time forum, and AI assistant.',
    keywords:
      'SAP, SAP S/4HANA, SD, MM, LE, Coaching, Offline Classes, LMS, SAP Training',
    og: {
      title: 'ShreeGuruCool – SAP S/4HANA Coaching Platform',
      description:
        'Learn SAP modules like SD, MM, and LE with live mentorship, offline coaching, and real-time community.',
      image: 'https://yourdomain.com/assets/preview-image.png',
      url: 'https://yourdomain.com/',
      type: 'website',
    },
    twitter: {
      card: 'summary_large_image',
      title: 'ShreeGuruCool – SAP Coaching',
      description:
        'Offline SAP training with real mentors and AI chatbot support.',
      image: 'https://yourdomain.com/assets/preview-image.png',
    },
  });

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const homeContent = await getPageContent('home');
        setData(homeContent);
      } catch (err) {
        console.error('Error fetching home content:', err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchContent();
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-50">
        <Loader />
      </div>
    );
  }

  return (
    <div className="space-y-0">
      <HeroSection content={data} />
      <FeaturesSection />
      <CoursesSection />
      <TestimonialsSection />
      <CompaniesSection />
      <CallToActionSection />
      <FloatingContactOptions />
      <ChatBot />
    </div>
  );
};

export default Home;
